import { useEffect } from 'react';
import { valorForcado } from './regrasCadastro';

/**
 * Mantém no Formik os valores travados por `forcarValorSe`. É componente (e não hook)
 * porque o render prop do Formik não é componente — lá dentro não dá pra usar efeito.
 */
export default function AplicarForcarValorSe({ campos, valores, setFieldValue }) {
  useEffect(() => {
    for (const campo of campos) {
      const forcado = valorForcado(campo, valores);
      if (forcado !== null && valores[campo.codigo] !== forcado) setFieldValue(campo.codigo, forcado);
    }
  }, [campos, valores, setFieldValue]);

  return null;
}
